import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


import {getToken } from '@/utils/auth'



import edsIndex from '@/components/eds/index';
import loginIndex from '@/components/user/login';
import booksIndex from '@/components/relate_books/list';
import xrbsBooksIndex from '@/components/xrbs/books';
import xrbsQuesIndex from '@/components/xrbs/questions';


export const constantRoutes = [
    {   path : '/eds' , 
        component : edsIndex,
        beforeEnter: (to, from, next) => {
            var userAccessToken = getToken();
            console.log('beforeEnter eds ' , userAccessToken);
            if(userAccessToken){
                next();
            }else{
                next('/login');
            }
        }
    },
    {   path : '/login' , 
        component : loginIndex 
    },
    {   path : '/books_rela' , 
        component : booksIndex,
        beforeEnter: (to, from, next) => {
            var userAccessToken = getToken();
            console.log('beforeEnter books ' , userAccessToken);
            if(userAccessToken){
                next();
            }else{
                next('/login');
            }
        }
    },
    {   path : '/books_xr' , 
        component : xrbsBooksIndex,
        beforeEnter: (to, from, next) => {
            var userAccessToken = getToken();
            console.log('beforeEnter books ' , userAccessToken);
            if(userAccessToken){
                next();
            }else{
                next('/login');
            }
        }
    },
    {   path : '/xrbs_questions' , 
        component : xrbsQuesIndex,
        beforeEnter: (to, from, next) => {
            var userAccessToken = getToken();
            console.log('beforeEnter books ' , userAccessToken);
            if(userAccessToken){
                next();
            }else{
                next('/login');
            }
        }
    },
    {
        path: '/', 
        redirect: '/eds' 
    }
]

export const asyncRoutes = [


]

const createRouter = () => new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})
  
const router = createRouter();


export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js